// Client mirror of COST_TABLE — must match supabase/functions/_shared/credits.ts
export const CREDIT_COSTS = {
  "analyze-niche": 3,
  "generate-tags": 2,
  "generate-design": 15,
  "generate-design-variations": 50,
  "publish-kit": 3,
  "generate-multiplatform-kit": 25,
  "generate-profile-bio": 2,
  "generate-profile-banner": 15,
  "detect-opportunities": 8,
  "compare-platforms": 3,
  "run-design-agent-standard": 250,
  "run-design-agent-pro": 450,
  "scrape-redbubble": 5,
} as const;

export type CreditAction = keyof typeof CREDIT_COSTS;

export const ACTION_LABELS: Record<CreditAction, string> = {
  "analyze-niche": "Analyze niche",
  "generate-tags": "Generate SEO tags",
  "generate-design": "Generate design",
  "generate-design-variations": "Generate 4 variations",
  "publish-kit": "Publish kit",
  "generate-multiplatform-kit": "Multi-platform kit",
  "generate-profile-bio": "Profile bio",
  "generate-profile-banner": "Profile banner",
  "detect-opportunities": "Detect opportunities",
  "compare-platforms": "Compare platforms",
  "run-design-agent-standard": "Design Agent (Standard)",
  "run-design-agent-pro": "Design Agent (Pro)",
  "scrape-redbubble": "Redbubble scraping",
};

export const PLANS = [
  {
    id: "free" as const,
    name: "Free",
    price: 0,
    credits: 100,
    badge: "No card required",
    features: [
      "100 credits/month",
      "Premium POD design generation",
      "Basic niche analyses",
      "Multi-platform publishing kit",
    ],
  },
  {
    id: "starter" as const,
    name: "Starter",
    price: 12,
    annualPrice: 100,
    credits: 1500,
    features: [
      "1,500 credits/month",
      "~6 Standard Autopilot Agents",
      "Unlimited light niche analyses",
      "Multi-platform kits (9 marketplaces)",
      "Email support",
    ],
  },
  {
    id: "pro" as const,
    name: "Pro",
    price: 34,
    annualPrice: 285,
    credits: 6000,
    popular: true,
    features: [
      "6,000 credits/month",
      "~24 Pro Autopilot Agents",
    "Premium image model access",
      "Live Redbubble data",
      "Priority support",
    ],
  },
  {
    id: "studio" as const,
    name: "Studio",
    price: 79,
    annualPrice: 663,
    credits: 20000,
    features: [
      "20,000 credits/month",
      "~80 Pro Autopilot Agents",
      "Unlimited Autopilot mode*",
      "For professional sellers",
      "Direct Slack with the team",
    ],
  },
];

export const LIFETIME = {
  id: "lifetime" as const,
  name: "Lifetime Founder",
  price: 197,
  creditsPerMonth: 3000,
  features: [
    "One-time payment, lifetime access",
    "3,000 credits/month forever",
    "All Pro features",
    "Early access to new features",
    "Only 100 seats available",
  ],
};

export const TOPUPS = [
  { credits: 600, price: 5 },
  { credits: 2800, price: 20 },
  { credits: 7500, price: 50 },
];
